import React, { useContext, Fragment } from "react";
import { AbilityContext } from "./context/Can";
import { subject } from "@casl/ability";
import { CurrentBuildingContext } from "../contexts/currentBuilding";

const Can2 = ({ I, a, y, children }) => {
  const ability = useContext(AbilityContext);
  const { currentBuilding } = useContext(CurrentBuildingContext);
  const view = y || currentBuilding?._id || "company";

  if (
    !ability.can(I, subject(a, { view })) &&
    !ability.can(I, subject(a, { view: "building" })) &&
    !ability.can(I, subject(a, { view: "company" })) &&
    !ability.can(I, a)
  ) return null;

  return <Fragment>{children}</Fragment>;
};

export default Can2;
